var React = require('react');

function Nav (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"className":"color","fill":"#F2C1B6"},React.createElement("g",null,React.createElement("g",null,React.createElement("path",{"d":"M33 0L75.505 0 412 0 404.743 21.756 412 72 33 72z","transform":"translate(-244 -152) translate(0 93) translate(0 59)"}))))));
}

Nav.defaultProps = {"preserveAspectRatio":"none","width":"168","height":"72","viewBox":"0 0 168 72"};

module.exports = Nav;

Nav.default = Nav;
